import Vuex, { mapMutations } from 'vuex';

const { mapState, mapGetters, mapActions } = Vuex;
const name_ = 'profile';

export const profileComputed = {
  ...mapState(name_, {
    taskInfo: state => state.tasks,
  }),
  ...mapGetters(name_, ['getTheme', 'getTask', 'getModifiers', 'getGroupBadgePoints', 'getBadgesByDate', 'getProgressionsLoggedOnDays', 'getTotalPoints', 'getGlobalTaskInfo']),
};

export const profileMethods = {
  ...mapMutations(name_, ['updateBadgePoints']),
  ...mapActions(name_, ['fetchProfile','setTheme', 'setTaskInfo', 'setModifiers', 'updateTaskInfo', 'getBadgeGroupCount', 'updateGlobalTaskInfo']),
};
